import api from './api';

// Support kişilerini getir
export const getSupportPersons = async () => {
  try {
    console.log('Fetching support persons...');
    const response = await api.get('/support/');
    console.log('Support persons received:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching support persons:', error);
    throw error;
  }
};

// Tek support kişisini getir
export const getSupportPerson = async (id) => {
  try {
    console.log('Fetching support person:', id);
    const response = await api.get(`/support/${id}`);
    console.log('Support person received:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching support person:', error);
    throw error;
  }
};

// Yeni support kişisi oluştur
export const createSupportPerson = async (data) => {
  try {
    console.log('Creating support person:', data);
    const response = await api.post('/support/', data, {
      timeout: 30000
    });
    console.log('Support person created:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error creating support person:', error);
    if (error.code === 'ECONNABORTED') {
      throw new Error('İstek zaman aşımına uğradı. Lütfen tekrar deneyin.');
    } else if (error.code === 'ERR_NETWORK') {
      throw new Error('Ağ hatası. İnternet bağlantınızı kontrol edin.');
    } else if (error.code === 'ERR_TUNNEL') {
      throw new Error('Bağlantı hatası. Lütfen daha sonra tekrar deneyin.');
    }
    throw error;
  }
};

// Support kişisini güncelle
export const updateSupportPerson = async (id, data) => {
  try {
    console.log('Updating support person:', id, data);
    const response = await api.put(`/support/${id}`, data, {
      timeout: 30000
    });
    console.log('Support person updated:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error updating support person:', error);
    if (error.code === 'ECONNABORTED') {
      throw new Error('İstek zaman aşımına uğradı. Lütfen tekrar deneyin.');
    } else if (error.code === 'ERR_NETWORK') {
      throw new Error('Ağ hatası. İnternet bağlantınızı kontrol edin.');
    } else if (error.code === 'ERR_TUNNEL') {
      throw new Error('Bağlantı hatası. Lütfen daha sonra tekrar deneyin.');
    }
    throw error;
  }
};

// Support kişisini sil
export const deleteSupportPerson = async (id) => {
  try {
    console.log('Deleting support person:', id);
    const response = await api.delete(`/support/${id}`);
    console.log('Support person deleted:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error deleting support person:', error);
    throw error;
  }
};

// Görsel dosyasını base64'e çevir
export const convertImageToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};
